/* eslint-disable sort-keys */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-cycle */
import React, { useState } from 'react'

import { AccordionItemComponent, TreatmentDetails } from '../../components'
import AccordionsWrapper from '../../components/AccordionsWrapper/AccordionsWrapper'
import LinkComponent from '../../components/LinkComponent/LinkComponent'
import { Kicker } from '../../components/Typography'
import { useMediaquery } from '../../hooks'
import { SectionContainer } from '../../layouts'
import { defaultLanguage } from '../../utils/appConfig'
import { ContentParser, hasNulls } from '../../utils/helpers'
import {
  activeItem,
  contentColor,
  headerStyling,
  itemStyling,
  sectionBackGround,
  treatmentsCardsContainer,
  treatmentsContainer,
  treatmentsContent,
  treatmentsNav,
  treatmentsNavItem,
} from './TreatmentSection.module.css'

const NewTreatmentSection = ({ lang, slice }) => {
  const [activeTreatment, setActiveTreatment] = useState(slice.treatmentsgroup1)
  const [active, setActive] = useState(0)
  const {
    treatmentscontainerwidth,
    treatmentsdescription,
    treatmentsheading,
    treatmentskicker,
  } = slice
  const treatments = ContentParser(slice, 'treatmentsgroup').filter(
    (res) => !hasNulls(Object.values(res)),
  )

  const backGroundArr = treatments.map((treatment) => treatment.treatmentsimage)

  const handleUspClick = (index, treatment) => {
    setActive(index)
    setActiveTreatment(treatment)
  }
  const isDesktop = useMediaquery('(min-width: 768px)')

  return (
    <SectionContainer
      activate={active}
      backGroundArr={backGroundArr}
      backgroundClassName={sectionBackGround}
      containerwidth={treatmentscontainerwidth}
      extraClassName={treatmentsContainer}
      extraContentFontClassName={contentColor}
      extraHeaderClassName={treatmentsContent}
      extraHeadingClassName={contentColor}
      extraHeadingContainerClassName={headerStyling}
      extraKickerClassName={contentColor}
      heading={treatmentsheading}
      kicker={treatmentskicker}
      renderedContent={treatmentsdescription}
      withHeader
    >
      {isDesktop && (
        <div className={treatmentsNav}>
          {treatments.length > 0 &&
            treatments.map((treatment, index) => {
              const { treatmentstitle } = treatment
              return (
                <div
                  key={index}
                  onClick={() => handleUspClick(index, treatment)}
                  onKeyUp={() => handleUspClick(index, treatment)}
                  role="button"
                  tabIndex="0"
                >
                  <p
                    className={`${treatmentsNavItem} ${
                      activeTreatment.treatmentstitle === treatmentstitle
                        ? activeItem
                        : ''
                    }`}
                  >
                    {treatmentstitle}
                  </p>
                </div>
              )
            })}
        </div>
      )}
      <AccordionsWrapper
        className={treatmentsCardsContainer}
        isDesktop={isDesktop}
      >
        {treatments.length > 0 &&
          treatments.map((treatment, index) => {
            const items = treatment?.treatmentspages?.nodes?.map(
              (treatmentItem, treatmentIndex) => {
                const name = treatmentItem.pageType.name || treatmentItem.title
                return (
                  <Kicker key={treatmentIndex} extraClassName={itemStyling}>
                    <LinkComponent
                      className={treatmentsContainer}
                      src={
                        lang === defaultLanguage.slice(0, 2)
                          ? `/${treatmentItem.pageType.uri}/`
                          : `/${lang.slice(0, 2)}/${
                              treatmentItem.pageType.uri
                            }/`
                      }
                    >
                      {name}
                    </LinkComponent>
                  </Kicker>
                )
              },
            )
            let ctaContent = treatment.treatmentscta1
            if (typeof treatment.treatmentscta1 === 'string') {
              ctaContent = JSON.parse(treatment.treatmentscta1)
            }
            return isDesktop ? (
              <TreatmentDetails
                key={index}
                activeTreatment={activeTreatment.treatmentstitle}
                extraClassName={itemStyling}
                lang={lang}
                treatment={treatment}
              />
            ) : (
              <AccordionItemComponent
                key={index}
                active={
                  activeTreatment.treatmentstitle === treatment.treatmentstitle
                }
                item={{
                  title: treatment.treatmentstitle,
                  image: treatment.treatmentsimage,
                  fieldGroupName: 'usp',
                  items,
                  cta: ctaContent,
                }}
                withoutTitle
                withUnderline
              />
            )
          })}
      </AccordionsWrapper>
    </SectionContainer>
  )
}

export default NewTreatmentSection
